import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

import styles from './Card.module.scss'

export const MasterCard = createValidIcon(() => {
  return (
    <svg
      className={styles.cardShadow}
      width='36'
      height='24'
      viewBox='0 0 36 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z'
        fill='#1A1A1A'
      />
      <path d='M21.238 6.16588H14.7432V17.8345H21.238V6.16588Z' fill='#FF5A00' />
      <path
        d='M15.1754 12.0001C15.1754 9.62942 16.2898 7.52531 18 6.16581C16.7414 5.17621 15.1537 4.57812 13.4219 4.57812C9.31946 4.57812 6 7.89762 6 12.0001C6 16.1027 9.31946 19.4222 13.4219 19.4222C15.1537 19.4222 16.7414 18.8241 18 17.8345C16.2874 16.4942 15.1754 14.3709 15.1754 12.0001Z'
        fill='#EB001B'
      />
      <path
        d='M30 12.0002C30 16.1027 26.6805 19.4222 22.5781 19.4222C20.8463 19.4222 19.2586 18.8241 18 17.8345C19.7318 16.4726 20.8246 14.3709 20.8246 12.0002C20.8246 9.62948 19.7102 7.52531 18 6.16581C19.2562 5.17621 20.8439 4.57818 22.5756 4.57818C26.6805 4.57818 30 7.91929 30 12.0002Z'
        fill='#F79E1B'
      />
    </svg>
  )
})
